export default __webpack_public_path__ + "static/logo-28b55141e68fb379ee030befb09ccc82.jpg";